import tippy from 'tippy.js'

const updateToolTipContent = (el: any, binding: any) => {
  if (!binding.value) return
  tippy(el, {
    theme: 'ahaslides',
    content: binding.value,
  })
}

export default {
  mounted(el: any, binding: any) {
    updateToolTipContent(el, binding)
  },
  updated(el: any, binding: any) {
    updateToolTipContent(el, binding)
  },
}
